export const UNREGISTERED_MOTO = {
  nickname: 'PRODUCTS.UNREGISTERED_MOTO.shortname',
  isHidden: true,
};
